import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { useParams } from 'react-router-dom';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useGetChartsData() {
    const {id} = useParams()
  return useQuery(['get-charts-data', id], async () => {
    const res = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.TASKS_CHARTS, {
        task_board_id: id,
      })
    );
    return res.data;
  });
}
